'use client'

import { useRef } from 'react'
import type { HTMLProps } from 'react'
import clsx from 'classnames'
import { motion, useScroll } from 'framer-motion'
import { variantsHeadline } from '@/shared/constants/variants'
import { IMainPageSettings } from '@/interfaces/pages'
import { IGoal } from '@/interfaces/goals'
import { CircleBg } from '@/shared/ui/circle-bg/circle-bg'
import { useAppearance } from '@/shared/utils'
import { Features } from './ui/features'
import style from './about-main.module.scss'

interface AboutMainProps extends HTMLProps<HTMLDivElement> {
  loaded?: boolean
  goals: IGoal[]
  mainPageSettings: IMainPageSettings | null
}

export const AboutMain = ({ className, loaded, goals, mainPageSettings }: AboutMainProps) => {
  const bgRef = useRef(null)
  const { scrollYProgress } = useScroll({
    target: bgRef,

    offset: ['start start', 'end start'],
  })

  const { ref: titleRef, animate: titleAnimate } = useAppearance()
  const { ref: textRef, animate: textAnimate } = useAppearance()

  return (
    <motion.section
      id="about-main"
      className={clsx(className, style.container, { [style.loaded]: loaded })}
      ref={bgRef}
    >
      <Features goals={goals} className={style.featuresWrapper} />

      <motion.div
        ref={titleRef}
        animate={titleAnimate}
        className={clsx(style.headline, 'text', 'text_type_l2')}
        variants={variantsHeadline}
        dangerouslySetInnerHTML={{ __html: mainPageSettings?.central_block_title ?? '' }}
      />

      <motion.div
        ref={textRef}
        animate={textAnimate}
        className={clsx(style.info, 'text', 'text_type_h3')}
        variants={variantsHeadline}
        dangerouslySetInnerHTML={{ __html: mainPageSettings?.central_block_description ?? '' }}
      />
      <CircleBg scrollYProgress={scrollYProgress} />
    </motion.section>
  )
}
